/**
 * Collection of utilities used for generating Universally Unique Identifiers.
 */ /**
 * Default namespaces for UUID v5 defined in RFC 4122
 */ export var Uuidv5Namespace = /*#__PURE__*/ function(Uuidv5Namespace) {
    // Source of the UUIDs: https://datatracker.ietf.org/doc/html/rfc4122
    Uuidv5Namespace["dns"] = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
    Uuidv5Namespace["url"] = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
    Uuidv5Namespace["oid"] = "6ba7b812-9dad-11d1-80b4-00c04fd430c8";
    Uuidv5Namespace["x500"] = "6ba7b814-9dad-11d1-80b4-00c04fd430c8";
    return Uuidv5Namespace;
}({});

//# sourceMappingURL=uuid.types.js.map
